import React from 'react'

export default function About() {
    return (
        <div>
            <div id="page-about" className="page">

                <section className="page-hero">
                    <div className="page-hero-bg"></div>
                    <div className="page-hero-content">
                        <div className="page-hero-eye">Our Story</div>
                        <h1 className="page-hero-title">Rooted in the land.<br />Guided by <em>nature's wisdom.</em></h1>
                        <div className="page-hero-rule"></div>
                        <p className="page-hero-sub">WOLFF was born from a simple belief: that working with the land — not against it — produces more beautiful, more enduring, and more meaningful results. We are stewards, not contractors.</p>
                    </div>
                </section>

                <div className="strip">
                    <div className="strip-item"><div className="strip-dot"></div>Founded in Erin, Ontario</div>
                    <div className="strip-item"><div className="strip-dot"></div>Organic &amp; Regenerative Since Day One</div>
                    <div className="strip-item"><div className="strip-dot"></div>SOUL Certified</div>
                    <div className="strip-item"><div className="strip-dot"></div>Fully Insured</div>
                </div>

                <section className="about-founders">
                    <div className="about-founders-head">
                        <div className="sec-eye">The Founders</div>
                        <h2 className="sec-title">The people behind<br /><em>every project</em></h2>
                    </div>
                    <div className="founders-grid">

                        <div className="founder-card">
                            <div className="founder-photo">
                                <div className="founder-photo-fill-1"></div>
                            </div>
                            <h3 className="founder-name">Kurt Wolff</h3>
                            <div className="founder-role">Co-Founder · Arborist &amp; Tree Care Lead</div>
                            <div className="founder-tree"><strong>Favourite Tree:</strong> The mighty Elm</div>
                            <div className="founder-did-you-know">
                                <div className="founder-dyk-label">Did You Know?</div>
                                <p className="founder-dyk-text">Elm trees are known for their water-resistant wood and rich history, making them an incredibly versatile material for woodworking.</p>
                            </div>
                            <div className="founder-bio">
                                <p>Kurt's connection to the land began early, growing up on a farm where he learned to operate machinery, maintain trails, cut wood for heat, and grow food alongside his family. With a lifelong passion for the outdoors and a background in Arboriculture studies at the University of Guelph, Kurt brings a deep respect for nature into every project.</p>
                                <p>He specializes in tree care and large-scale property work, where safety, precision, and problem-solving are essential. From planting to complex removals, Kurt approaches each project with care for both the surrounding landscape and its long-term ecological impact.</p>
                                <p>He is driven by a desire to protect native forests, clean waterways, and preserve biodiversity. Kurt values working with clients who share a respect for the land and a commitment to maintaining healthy ecosystems for future generations.</p>
                            </div>
                        </div>

                        <div className="founder-card">
                            <div className="founder-photo">
                                <div className="founder-photo-fill-2"></div>
                            </div>
                            <h3 className="founder-name">Alex Wolff</h3>
                            <div className="founder-role">Ecological Landscape Designer · Organic Land Care</div>
                            <div className="founder-tree"><strong>Favourite Tree:</strong> The wise Pawpaw Tree</div>
                            <div className="founder-did-you-know">
                                <div className="founder-dyk-label">Did You Know?</div>
                                <p className="founder-dyk-text">Pawpaw trees are a native species with tropical-tasting fruit and play an important role in supporting the zebra swallowtail butterfly.</p>
                            </div>
                            <div className="founder-bio">
                                <p>Alex's work is deeply rooted in her connection to the land, healing, and the natural world. What began as a personal journey into growing food, herbs, and medicine quickly evolved into a passion for soil health, plant systems, and the relationships within ecosystems.</p>
                                <p>She is especially passionate about designing and planting rich, living landscapes that nourish both people and the environment. Her work often includes edible, medicinal, and pollinator-supporting species.</p>
                                <p>She is motivated to create change within the landscaping industry by offering natural alternatives that support the health of families, communities, and the planet — helping people reconnect with their land and the rhythms of nature.</p>
                            </div>
                        </div>

                    </div>
                </section>

                <section class="about-values">
                    <div class="about-values-head">
                        <div class="sec-eye">What We Stand For</div>
                        <h2 class="sec-title">Three principles that guide <em>every decision</em></h2>
                    </div>
                    <div class="values-grid">
                        <div className="val-card">
                            <div className="val-num">01</div>
                            <div className="val-title">The Land Comes First</div>
                            <p className="val-body">Before aesthetics, before budget, before convenience — we ask what this land needs. Our practice is rooted in soil science, native ecology, and regenerative principles that return vitality to the earth.</p>
                        </div>
                        <div class="val-card">
                            <div class="val-num">02</div>
                            <div class="val-title">No Chemical Shortcuts</div>
                            <p class="val-body">We do not use synthetic pesticides, herbicides, or fertilizers — period. Not as a selling point, but as a non-negotiable conviction. We achieve results through knowledge, timing, and respect for natural processes.</p>
                        </div>
                        <div className="val-card">
                            <div className="val-num">03</div>
                            <div className="val-title">Relationships Over Transactions</div>
                            <p className="val-body">We take on a limited number of clients to ensure every property receives our genuine attention. We want to understand your land across seasons, build on what we learn, and grow something lasting together.</p>
                        </div>
                    </div>
                </section>

                <section className="about-origin">
                    <div className="about-origin-inner">
                        <div className="sec-eye">Our Roots</div>
                        <h2 className="about-origin-title">Every great story begins <em>somewhere</em></h2>

                        <p>WOLFF began the same way most plants do — from the ground up.</p>

                        <p>Kurt and Alex first met in their youth, in the backyard of a mutual friend's house party. Their story is one that unfolded over time, reconnecting years later with a shared passion for the outdoors, a deep respect for the land, and a desire to build a life rooted in both.</p>

                        <p>Before WOLFF, Alex explored multiple paths in business, all of which eventually led her back to what felt most aligned — working with plants. What started as a personal garden grew into something much more as she discovered the power of growing her own food, medicine, and reconnecting with the land. Seeing a lack of natural and authentic approaches in the landscaping industry, she knew there was an opportunity to do things differently.</p>

                        <p>As the vision began to take shape, Kurt stepped in, bringing with him a lifetime of hands-on experience from growing up on a farm. With a strong background in working with machinery, building, and land care, he chose to pursue work that aligned with his values and connection to nature.</p>

                        <div className="about-origin-pull">Together, they built WOLFF to create landscapes that don't just look good, but do good — for the soil, the water, the wildlife, and the people who live alongside it.</div>

                        <p>The name WOLFF, a family name, reflects their mission: <strong >Working on Land, Forest &amp; Flower.</strong> It represents their full-circle approach to caring for the land, preserving native ecosystems, and creating spaces that are both functional and meaningful.</p>

                        <p>One of their early defining moments came after helping a large property transition away from chemical treatments. That shift reinforced what they already believed — that small, intentional changes can create lasting environmental impact.</p>

                        <p>WOLFF has been built by hand, shaped by passion, and guided by a commitment to ecological harmony, regeneration, and sustainable living.</p>

                        <p>Looking ahead, their vision is to continue growing WOLFF with intention — restoring ecosystems, planting native species, and creating meaningful impact across the communities they serve.</p>

                        <div className="about-origin-pull">Like the rings of a tree, they believe the most meaningful work takes time, care, and patience.</div>
                    </div>
                </section>

                <section className="about-certs">
                    <div className="about-certs-head">
                        <div className="sec-eye">Credentials &amp; Certifications</div>
                        <h2 className="sec-title-light">Accountable to a<br /><em>higher standard</em></h2>
                    </div>
                    <div className="certs-grid">
                        <div className="cert-card">
                            <div className="cert-icon">S</div>
                            <div className="cert-title">SOUL Certified</div>
                            <p className="cert-desc">Stewards of Our Urban Lands — organic land care certification, verified annually.</p>
                        </div>
                        <div className="cert-card">
                            <div className="cert-icon">✦</div>
                            <div className="cert-title">Fully Insured</div>
                            <p className="cert-desc">Our team of fully insured arborists provides liability and WSIB coverage for all crew members and every job.</p>
                        </div>
                        <div className="cert-card">
                            <div className="cert-icon">P</div>
                            <div className="cert-title">Permaculture Design</div>
                            <p className="cert-desc">PDC-trained in ecological design and regenerative land management systems.</p>
                        </div>
                    </div>
                </section>

                <section className="cta">
                    <h2 className="cta-title">Every healthy landscape starts with<br /><em>understanding the local ecosystem.</em></h2>
                    <p className="cta-sub">Tell us about your property and what you're dreaming of or envisioning.</p>
                    <a href="/contact" className="btn-primary">Book a Free Consultation</a>
                </section>
            </div>
        </div>
    )
}
